export const MAX_POLL_OPTIONS = 100 as const;

export const MAX_OPTIONS_DISPLAYED = 5 as const;
export const COUNT_OPTION_VOTES_PREVIEW = 5 as const;
